import { GetEventsSettings, GetEventsSettingsParams } from '@/domain/usecases'
import { AccessDeniedError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'
import { HttpClient, HttpRequest, HttpStatusCode } from '@/data/protocols'
import { EventsSettingsModel } from '@/domain/models'

export class RemoteGetEventsSettings implements GetEventsSettings {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<EventsSettingsModel>
  ) { }

  async getAll (params: GetEventsSettingsParams): Promise<EventsSettingsModel> {
    const request: HttpRequest = {
      url: `${this.url}/api/portal/sigmadesk/listar-eventos`,
      method: 'get',
      params
    }

    const { statusCode, body } = await this.httpClient.request(request)

    switch (statusCode) {
      case HttpStatusCode.ok:
        if (!body) {
          throw new UnexpectedResultFormatError()
        }
        return body
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
